import {
  createExternalRouteRef,
  createRouteRef,
} from '@backstage/frontend-plugin-api';

/** The My Assets page at `/my-assets`. */
export const myEntitiesRouteRef = createRouteRef();

export const viewTechDocRouteRef = createExternalRouteRef({
  params: ['namespace', 'kind', 'name'],
  defaultTarget: 'techdocs.docRoot',
});

export const createFromTemplateRouteRef = createExternalRouteRef({
  params: ['namespace', 'templateName'],
  defaultTarget: 'scaffolder.selectedTemplate',
});

export const catalogIndexRouteRef = createExternalRouteRef({
  defaultTarget: 'catalog.catalogIndex',
});
